import { useEffect, useState } from "react";
import { api, trackVisit } from "../lib/api";
import PageHero from "../components/site/PageHero";
import { Star } from "lucide-react";
import { toast } from "sonner";

export default function Recensioni() {
  const [reviews, setReviews] = useState([]);
  const [form, setForm] = useState({ name: "", city: "", rating: 5, text: "" });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    trackVisit("recensioni");
    api.get("/reviews").then((r) => setReviews(r.data));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/reviews", form);
      toast.success("Recensione inviata! Sarà pubblicata dopo la moderazione.");
      setForm({ name: "", city: "", rating: 5, text: "" });
    } catch (err) {
      toast.error("Errore nell'invio. Riprova.");
    } finally {
      setSubmitting(false);
    }
  };

  const avg = reviews.length ? reviews.reduce((s, r) => s + r.rating, 0) / reviews.length : 0;

  return (
    <div data-testid="recensioni-page">
      <PageHero eyebrow="Recensioni" title="La nostra reputazione," titleAccent="scritta dai clienti." />

      <section className="py-12">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-wrap items-center gap-8">
          <div>
            <div className="font-serif text-6xl gold-text">{avg.toFixed(1)}</div>
            <div className="text-xs uppercase tracking-widest text-white/40 mt-1">Media valutazioni</div>
          </div>
          <div className="flex gap-1">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={28} fill={i < Math.round(avg) ? "#D4AF37" : "transparent"} className="text-[var(--gold)]" />
            ))}
          </div>
          <div className="text-white/60">basato su <strong className="text-white">{reviews.length}</strong> recensioni verificate</div>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div key={r.id} data-testid={`recensione-${r.id}`} className="luxe-card p-8">
              <div className="flex gap-1 mb-4">
                {[...Array(r.rating)].map((_, i) => (
                  <Star key={i} size={14} fill="#D4AF37" className="text-[var(--gold)]" />
                ))}
              </div>
              <p className="font-serif text-lg text-white/90 leading-relaxed italic mb-6">"{r.text}"</p>
              <div className="text-sm text-[var(--gold)] font-medium">{r.name}</div>
              <div className="text-xs text-white/40">{r.city} · {new Date(r.created_at).toLocaleDateString("it-IT")}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-[#060f1f]">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="font-serif text-4xl text-white mb-3 text-center">Lascia la tua <span className="gold-text italic">recensione</span></h2>
          <p className="text-center text-white/60 mb-10 text-sm">La tua opinione è preziosa quanto i metalli che valutiamo.</p>
          <form onSubmit={submit} className="space-y-5">
            <div className="grid md:grid-cols-2 gap-5">
              <input data-testid="review-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nome e Cognome" className="w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder:text-white/30 focus:border-[var(--gold)] outline-none" />
              <input data-testid="review-city" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="Città (opzionale)" className="w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder:text-white/30 focus:border-[var(--gold)] outline-none" />
            </div>
            <div className="flex items-center gap-3">
              <span className="text-white/60 text-sm">Valutazione:</span>
              {[1, 2, 3, 4, 5].map((n) => (
                <button type="button" key={n} onClick={() => setForm({ ...form, rating: n })} data-testid={`rating-${n}`}>
                  <Star size={26} fill={n <= form.rating ? "#D4AF37" : "transparent"} className="text-[var(--gold)]" />
                </button>
              ))}
            </div>
            <textarea data-testid="review-text" required value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} placeholder="Raccontaci la tua esperienza..." rows={5} className="w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder:text-white/30 focus:border-[var(--gold)] outline-none" />
            <button type="submit" data-testid="review-submit" disabled={submitting} className="btn-gold w-full justify-center">
              {submitting ? "Invio..." : "Invia Recensione"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
